import { notification } from 'antd';

const defaultConfig = {
  placement: 'top' as const,
  duration: 3,
  maxCount: 1,
};

export const notify = {
  success: (message: string, description?: string) => {
    notification.success({
      message,
      description,
      ...defaultConfig,
    });
  },

  error: (message: string, description?: string) => {
    notification.error({
      message,
      description,
      ...defaultConfig,
    });
  },

  warning: (message: string, description?: string) => {
    notification.warning({
      message,
      description,
      ...defaultConfig,
    });
  },
};

notification.config({
  placement: 'top',
  duration: 3,
  maxCount: 1,
});
